module.exports = __webpack_public_path__ + "static/media/ic-tags.ebe3e96c.svg";